<template>
  <Checkbox
    v-if="params.data.type != 'TOTAL'"
    v-model="checked"
    :disabled="params.disabled"
    :binary="true"
    class="mb-2"
    @change="params.setDefaultPayee(params.node.id, checked)"
  />
</template>

<script setup lang="ts">
const props = defineProps(["params"]);

const checked = ref(props.params.data.defaultPayee);
</script>
